module.exports = __webpack_public_path__ + "public/images/slider/malafeeva-circle.f51ab8cf5eac19c8b1e597bccac2db0c.webp";